import { Link, useLocation } from "react-router-dom";
import { Activity } from "lucide-react";

export default function Header({ minimal = false }) {
  const loc = useLocation();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FAF9F6]/85 border-b border-[#2D4A3E]/10">
      <div className="max-w-5xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span className="h-9 w-9 rounded-xl bg-[#2D4A3E] text-white grid place-items-center">
            <Activity size={18} strokeWidth={1.8} />
          </span>
          <span className="font-display text-lg text-[#1A231F]">Studio DeRobertis</span>
        </Link>
        {!minimal && (
          <nav className="hidden sm:flex items-center gap-7 text-sm text-[#5C7066]">
            <Link data-testid="nav-trattamenti" to="/trattamenti" className={loc.pathname==="/trattamenti"?"text-[#2D4A3E]":""}>Trattamenti</Link>
            <Link data-testid="nav-prenota" to="/prenota" className={loc.pathname==="/prenota"?"text-[#2D4A3E]":""}>Prenota</Link>
          </nav>
        )}
      </div>
    </header>
  );
}
